const initialState = {};

const strapiRes = (state = initialState, action) => {
  switch (action.type) {
    case "SET_STRAPI_RES_DATA":
      return action.payload;
    case "LOGOUT_SUCCESS":
      return initialState;
    default:
      return state;
  }
};

export default strapiRes;
